document.addEventListener('DOMContentLoaded', function() {
  // Función para scroll suave hacia la pregunta
  function scrollToQuestion(questionId) {
    // Buscar el details element que contiene la pregunta
    const targetElement = document.querySelector(`details[id*="Details-${questionId}-"]`);
    if (targetElement) {
      // Pequeño delay para permitir que la pregunta se abra primero
      setTimeout(() => {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
        
        // Agregar efecto de resaltado temporal al contenedor accordion
        const accordionContainer = targetElement.closest('.accordion');
        if (accordionContainer) {
          accordionContainer.classList.add('highlighted');
          setTimeout(() => {
            accordionContainer.classList.remove('highlighted');
          }, 2000);
        }
      }, 300);
    }
  }

  // Manejar clics en los enlaces del índice
  function handleIndexLinks() {
    const indexLinks = document.querySelectorAll('a[href^="#q"]');
    indexLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const questionId = this.getAttribute('href').replace('#', '');
        const targetDetails = document.querySelector(`details[id*="Details-${questionId}-"]`);
        
        if (targetDetails) {
          // Si la pregunta está cerrada, abrirla primero
          if (!targetDetails.open) {
            const summary = targetDetails.querySelector('summary');
            if (summary) {
              summary.click();
            }
          }
          
          // Scroll hacia la pregunta
          scrollToQuestion(questionId);
        }
      });
    });
  }

  // Inicializar manejadores de enlaces
  handleIndexLinks();

  // También manejar navegación directa con hash en la URL
  if (window.location.hash) {
    const questionId = window.location.hash.replace('#', '');
    const targetDetails = document.querySelector(`details[id*="Details-${questionId}-"]`);
    
    if (targetDetails) {
      // Esperar un poco para que la página cargue completamente
      setTimeout(() => {
        if (!targetDetails.open) {
          const summary = targetDetails.querySelector('summary');
          if (summary) {
            summary.click();
          }
        }
        
        scrollToQuestion(questionId);
      }, 500);
    }
  }
});
